import { transparentize } from 'polished';
import styled from 'styled-components';

import {
  breakpoints,
  colors,
  convertPxToRem,
  InterFont,
  paragraphs,
  titles
} from '@proprioo/salatim';

export const ExistingCustomer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${transparentize(0.08, 'white')};
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${convertPxToRem(24)};
`;

export const ExistingMessage = styled.p`
  ${titles.h4};
  ${InterFont};
  color: ${colors.dark.base80};
  margin-bottom: ${convertPxToRem(24)};
  text-align: center;
`;

export const ExistingContractMessage = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.dark.base80};
  margin-bottom: ${convertPxToRem(16)};
  column-gap: ${convertPxToRem(16)};
`;

export const SubtitleMessage = styled.p`
  ${paragraphs.body1}
  color: ${colors.dark.base80};
  margin-bottom: ${convertPxToRem(24)};
  text-align: center;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  button + button {
    margin-top: ${convertPxToRem(16)};
  }

  @media (min-width: ${breakpoints.xsmall}px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    button {
      flex-shrink: 0;
      margin-top: ${convertPxToRem(16)};
    }

    button + button {
      margin-left: ${convertPxToRem(16)};
    }
  }
`;

export const WarningWrapper = styled.div`
  width: ${convertPxToRem(72)};
  height: ${convertPxToRem(72)};

  svg {
    width: 100%;
    height: 100%;
    fill: ${colors.red.base};
  }
`;
